import { createSlice } from "@reduxjs/toolkit";

export type BookmarksState = {
  isBookmarksIntroModalVisible: boolean;
  bookmarkAdded: boolean | null;
};

const initialState: BookmarksState = {
  isBookmarksIntroModalVisible: false,
  bookmarkAdded: false,
};

export const bookmarksSlice = createSlice({
  name: "bookmarks",
  initialState,
  reducers: {
    showBookmarksIntro(state) {
      state.isBookmarksIntroModalVisible = true;
    },
    hideBookmarksIntro(state) {
      state.isBookmarksIntroModalVisible = false;
    },
    addBookmark(state) {
      state.bookmarkAdded = true;
    },
  },
});

export const { showBookmarksIntro, hideBookmarksIntro, addBookmark } =
  bookmarksSlice.actions;
